import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

/**
 * 観測テレメトリ（Datadog RUM）にログインユーザーの識別子・属性を付与する。
 *
 * React 側 `frontend/src/observability/user.ts` の legacy(Vue) 版。付与内容も揃える:
 * - id: 常に付与（識別子）
 * - plan: 課金状態（'paid' / 'trial' / 'free'）を is_plan / is_in_paid_trial から導出
 * - sex: 分析の切り口用
 *
 * PII（メール / 氏名等）は送らない（プライバシー優先で固定）。
 * legacy には /me 取得の choke point が無いため、bootstrap.js の axios response
 * interceptor から `/api/user/get/me` レスポンス時に呼び出す（一点配線）。
 * Datadog は init 済みの時のみ反映される（未 init なら setUser は no-op 相当）。
 */

// 注: legacy(window.axios) はレスポンスを camelCase 化しないため snake_case のまま参照する
// （React 側は camelCase 化されるので isPlan / isInPaidTrial を使う点が異なる）。
function resolvePlan(user) {
    if (user.is_in_paid_trial) {
        return "trial";
    }
    if (user.is_plan) {
        return "paid";
    }
    return "free";
}

// 同一 identity への重複適用を避ける（/me は多数の画面で呼ばれるため）。clear でリセットする。
let lastAppliedKey = null;

export function setObservabilityUser(user) {
    if (user == null || user.id == null) {
        return;
    }
    const id = String(user.id);
    const sex = user.sex != null ? String(user.sex) : undefined;
    const plan = resolvePlan(user);

    const key = `${id}|${sex ?? ""}|${plan}`;
    if (key === lastAppliedKey) {
        return;
    }
    lastAppliedKey = key;

    const datadogUser = {
        id,
        plan,
        ...(sex ? { sex } : {}),
    };
    datadogRum.setUser(datadogUser);
    // Log Explorer 側でも @usr.id / @usr.plan で絞れるようにログにも同じ属性を載せる。
    datadogLogs.setUser(datadogUser);
}

export function clearObservabilityUser() {
    lastAppliedKey = null;
    datadogRum.clearUser();
    datadogLogs.clearUser();
}
